import { Box, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function MacroContentView({ content }) {
    return (
        <If truthy={!!content}>
            <Box className="styled-bullets" dangerouslySetInnerHTML={{ __html: content }} />
            <Else>
                <Typography>No content.</Typography>
            </Else>
        </If>
    )
}
